export default __webpack_public_path__ + "static/media/filmes.cbd46144.png";